import { IonSkeletonText } from '@ionic/react';
import classes from './style.module.scss';

const WorkoutInfoContainerLoader = () => {
  return (
    <div className={classes.workoutTitleHead}>
      <IonSkeletonText animated className={classes.image} />
      <div
        className={classes.workoutInfoContainer}
        style={{ background: 'none' }}
      >
        <div className={classes.workoutInfo}>
          <IonSkeletonText
            animated
            className={classes.workoutName}
            style={{ width: 100 }}
          />
          <div className={classes.workoutCategoryDescription}>
            <IonSkeletonText
              animated
              className={classes.workoutName}
              style={{ width: 150 }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkoutInfoContainerLoader;
